import { VoicePreference } from '../../services/cxone-sdk.service';
import { CXoneState } from '../../types';
import { CxoneSessionRefs } from './types';
import { useCxoneReconnect } from './useCxoneReconnect';
import { useCxoneForceLogout } from './useCxoneForceLogout';

interface UseCxoneRecoveryOptions {
  refs: CxoneSessionRefs;
  initializeWithVoicePreference: (preference: VoicePreference) => Promise<void>;
  setState: React.Dispatch<React.SetStateAction<CXoneState>>;
  setHasSessionConflict: React.Dispatch<React.SetStateAction<boolean>>;
  setNeedsVoicePreference: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useCxoneRecovery(options: UseCxoneRecoveryOptions) {
  const reconnect = useCxoneReconnect(options);
  const forceLogout = useCxoneForceLogout(options);

  return {
    ...reconnect,
    ...forceLogout,
  };
}
